import React from "react";
import Department from "./Department";

interface Props {
  departments: readonly Department[];
  onSelectDepartment: (department: Department) => void;
}

const departmentIcons: Record<string, string> = {
  Accounting:
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/accounting-icon.png",
  "Admin/Support":
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/support-icon.png",
  "Child Care Center":
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/child-care-icon.png",
  Compliance:
    "//cdnimg.webstaurantstore.com/uploads/design/2024/8/compliance-icon.png",
  Content:
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/content-icon.png",
  "Customer Solutions":
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/customer-solution-icon.png",
  "Design and Construction":
    "//cdnimg.webstaurantstore.com/uploads/design/2024/8/construction-icon.png",
  Development:
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/dev-icon.png",
  Distribution:
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/distribution-icon.png",
  Engineering:
    "//cdnimg.webstaurantstore.com/uploads/design/2024/8/engineering-icon.png",
  "Food Service":
    "//cdnimg.webstaurantstore.com/uploads/design/2024/8/foodservice-icon.png",
  Internship:
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/intern-icon.png",
  IT: "//cdnimg.webstaurantstore.com/uploads/design/2017/5/it-icon.png",
  Legal: "//cdnimg.webstaurantstore.com/uploads/design/2024/8/legal-icon.png",
  Logistics:
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/logistics-icon.png",
  Management:
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/management-icon.png",
  Marketing:
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/marketing-icon.png",
  Media: "//cdnimg.webstaurantstore.com/uploads/design/2017/5/photo-icon.png",
  "Photo/Video":
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/photo-icon.png",
  Sales: "//cdnimg.webstaurantstore.com/uploads/design/2017/5/sales-icon.png",
  Financial:
    "//cdnimg.webstaurantstore.com/uploads/design/2017/5/competitive-salary-icon.png",
  Purchasing:
    "//cdnimg.webstaurantstore.com/uploads/design/2024/8/purchasing-icon.png",
  "Supply Chain":
    "//cdnimg.webstaurantstore.com/uploads/images/2021/8/supplychain-icon.png",
  Service:
    "//cdnimg.webstaurantstore.com/uploads/images/2022/5/service-icon.png",
};

export default function DepartmentsGrid({
  departments,
  onSelectDepartment,
}: Props) {
  return (
    <div
      className="careers-positions-department-grid open"
      id="department-grid"
    >
      {departments.map((singleDepartment) => {
        return (
          <button
            type="button"
            key={`${singleDepartment.id}-department-button`}
            id={`${singleDepartment.id}-department`}
            className="job-count careers-positions-block"
            data-department-name={singleDepartment.name}
            onClick={() => onSelectDepartment(singleDepartment)}
          >
            <div className="careers-positions-block-content">
              <div className="careers-positions-block-container">
                <img src={departmentIcons[singleDepartment.name]} alt="" />
                <h3 className="careers-positions__block-title">
                  {singleDepartment.name}
                </h3>
                <div className="careers-positions__block-openings">
                  <span className="job-count text-gray-700">
                    {singleDepartment.jobCount} Openings
                  </span>
                </div>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
